import { useNavigate } from 'react-router-dom';
import { useOrder } from '../../hooks/useOrder';
import { useEffect, useState } from 'react'
import './index.css'
import { OrderType } from '../../contexts/OrderContext';
import { PiFunnel } from 'react-icons/pi';

type MiniHeaderProps = {
    title: string;
    name: string;
    fontColor: string;
    backgroundColor: string;
    fontCart?: string;
    backgroundCart?: string;
}

export function MiniHeader({ title, name, fontColor, backgroundColor, fontCart, backgroundCart }: MiniHeaderProps) {

    const navigate = useNavigate();
    const orderContext = useOrder();
    const [order, setOrder] = useState<OrderType>();

    async function loadOrder() {
        const newOrder = await orderContext.getOrder();
        setOrder(newOrder);
    }

    useEffect(() => {
        loadOrder()
    }, [])

    useEffect(() => {
        loadOrder();
    }, [orderContext]);

    function verificaSvg(name: string) {
        switch (name) {
            case 'filter':
                return (
                    <>
                        <PiFunnel color={fontColor}

                            size={'28px'}

                        />
                       
                    </>
                )
            case 'favorites':
                return (
                    <svg width="31" height="27" viewBox="0 0 31 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.0996 25.8809C15.2198 25.9603 15.34 26 15.4601 26C15.5803 26 15.7004 25.9603 15.8206 25.8809C16.3814 25.4838 30 15.954 30 8.13168C30 4.75656 27.9973 2.13587 24.7528 1.30202C21.7487 0.547575 17.7833 1.50055 15.5002 4.67714C13.0568 1.30202 9.05136 0.507868 6.16742 1.26231C2.96304 2.09616 1.00035 4.75656 1.00035 8.13168C0.920244 15.954 14.4988 25.4838 15.0996 25.8809Z" fill="#636363" stroke="#636363" strokeMiterlimit="10" />
                    </svg>
                )
            case 'cart':
                if (order && order.products.length > 0) {
                    return (
                        <div className="cart-with-items">
                            <svg width="27" height="25" viewBox="0 0 27 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.75 0H2.48438C3.46875 0 4.3125 0.609375 4.64062 1.5H25.2656C26.25 1.5 26.9531 2.4375 26.7188 3.375L24.75 11.25C24.4219 12.5625 23.2031 13.5 21.8438 13.5H7.125L7.45312 15.3281C7.59375 16.0312 8.25 16.5 8.95312 16.5H23.25C23.625 16.5 24 16.875 24 17.25C24 17.6719 23.625 18 23.25 18H8.95312C7.5 18 6.28125 17.0156 6 15.6094L3.23438 2.10938C3.1875 1.78125 2.85938 1.5 2.48438 1.5H0.75C0.328125 1.5 0 1.17188 0 0.75C0 0.375 0.328125 0 0.75 0ZM4.96875 3L6.79688 12H21.8438C22.5469 12 23.1562 11.5312 23.2969 10.875L25.2656 3H4.96875ZM7.875 21.375C7.875 22.0312 8.34375 22.5 9 22.5C9.60938 22.5 10.125 22.0312 10.125 21.375C10.125 20.7656 9.60938 20.25 9 20.25C8.34375 20.25 7.875 20.7656 7.875 21.375ZM11.625 21.375C11.625 22.3594 11.1094 23.2031 10.3125 23.6719C9.46875 24.1406 8.48438 24.1406 7.6875 23.6719C6.84375 23.2031 6.375 22.3594 6.375 21.375C6.375 20.4375 6.84375 19.5938 7.6875 19.125C8.48438 18.6562 9.46875 18.6562 10.3125 19.125C11.1094 19.5938 11.625 20.4375 11.625 21.375ZM21 20.25C20.3438 20.25 19.875 20.7656 19.875 21.375C19.875 22.0312 20.3438 22.5 21 22.5C21.6094 22.5 22.125 22.0312 22.125 21.375C22.125 20.7656 21.6094 20.25 21 20.25ZM21 24C20.0156 24 19.1719 23.5312 18.7031 22.6875C18.2344 21.8906 18.2344 20.9062 18.7031 20.0625C19.1719 19.2656 20.0156 18.75 21 18.75C21.9375 18.75 22.7812 19.2656 23.25 20.0625C23.7188 20.9062 23.7188 21.8906 23.25 22.6875C22.7812 23.5312 21.9375 24 21 24Z"
                                    fill={fontColor} />
                            </svg>
                            <div className='circle-number' style={backgroundCart ? { backgroundColor: backgroundCart } : {}}>
                                <p style={fontCart ? { color: fontCart } : {}}>{order && order.products.filter((product) => !product.table).length}</p>
                            </div>
                        </div>
                    )
                } else {
                    return (
                        <svg width="27" height="25" viewBox="0 0 27 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.75 0H2.48438C3.46875 0 4.3125 0.609375 4.64062 1.5H25.2656C26.25 1.5 26.9531 2.4375 26.7188 3.375L24.75 11.25C24.4219 12.5625 23.2031 13.5 21.8438 13.5H7.125L7.45312 15.3281C7.59375 16.0312 8.25 16.5 8.95312 16.5H23.25C23.625 16.5 24 16.875 24 17.25C24 17.6719 23.625 18 23.25 18H8.95312C7.5 18 6.28125 17.0156 6 15.6094L3.23438 2.10938C3.1875 1.78125 2.85938 1.5 2.48438 1.5H0.75C0.328125 1.5 0 1.17188 0 0.75C0 0.375 0.328125 0 0.75 0ZM4.96875 3L6.79688 12H21.8438C22.5469 12 23.1562 11.5312 23.2969 10.875L25.2656 3H4.96875ZM7.875 21.375C7.875 22.0312 8.34375 22.5 9 22.5C9.60938 22.5 10.125 22.0312 10.125 21.375C10.125 20.7656 9.60938 20.25 9 20.25C8.34375 20.25 7.875 20.7656 7.875 21.375ZM11.625 21.375C11.625 22.3594 11.1094 23.2031 10.3125 23.6719C9.46875 24.1406 8.48438 24.1406 7.6875 23.6719C6.84375 23.2031 6.375 22.3594 6.375 21.375C6.375 20.4375 6.84375 19.5938 7.6875 19.125C8.48438 18.6562 9.46875 18.6562 10.3125 19.125C11.1094 19.5938 11.625 20.4375 11.625 21.375ZM21 20.25C20.3438 20.25 19.875 20.7656 19.875 21.375C19.875 22.0312 20.3438 22.5 21 22.5C21.6094 22.5 22.125 22.0312 22.125 21.375C22.125 20.7656 21.6094 20.25 21 20.25ZM21 24C20.0156 24 19.1719 23.5312 18.7031 22.6875C18.2344 21.8906 18.2344 20.9062 18.7031 20.0625C19.1719 19.2656 20.0156 18.75 21 18.75C21.9375 18.75 22.7812 19.2656 23.25 20.0625C23.7188 20.9062 23.7188 21.8906 23.25 22.6875C22.7812 23.5312 21.9375 24 21 24Z"
                                fill={fontColor} />
                        </svg>
                    )
                }
            default:
                return (<></>)
        }
    }

    return (
        <div className='all-miniheader'>
            <div className="miniheader" style={{ backgroundColor: backgroundColor }}>
                <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => navigate(-1)}>
                    <path fillRule="evenodd" clipRule="evenodd" d="M0.225521 8.54307C-0.0751736 8.24288 -0.0751736 7.7579 0.225521 7.45693L7.362 0.325723C7.79608 -0.108574 8.50232 -0.108574 8.93717 0.325723C9.37125 0.760021 9.37125 1.46488 8.93717 1.89917L2.83231 8.00039L8.93717 14.1C9.37125 14.5351 9.37125 15.24 8.93717 15.6743C8.50232 16.1086 7.79608 16.1086 7.362 15.6743L0.225521 8.54307Z"
                        fill={fontColor} />
                </svg>
                <div className='title'>
                    <p style={{ color: fontColor }}>{title}</p>
                    {verificaSvg(name)}
                </div>
                <div />
            </div>
        </div>
    )
}